import { FC, useMemo, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import HotTable, { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { LocaleKey, useTranslation } from 'helpers/languages/translations';
import { MObjectifSearchHeader, translateHeaders } from './helpers/HeadersList';
import Grid from '../Grid';
import { listValidator, numberValidator } from '../Validators';
import { requireTitle } from './helpers/utils';
import { AutoCompleteRenderer } from './helpers/customRenderers';

export const MObjectifSearch: FC<{
    list: IList;
    toolId: number;
    status: string[];
}> = ({ list, toolId, status }) => {
    const translatedHeaders = translateHeaders(MObjectifSearchHeader);
    const hotRef = useRef<HotTable | null>(null);
    const translate = useTranslation();
    const noStatus = translate('list.dropdown.value.no_status' as LocaleKey) as string;
    const newStatus = [noStatus, ...status];

    const afterValidate = (listToValidate: IList) => {
        const newData = [...listToValidate.data].map((row) => {
            if (row[0] === noStatus) {
                const newRow = [...row];
                newRow[0] = 'no_status';
                return newRow;
            }
            return row;
        });

        return { ...listToValidate, data: newData };
    };

    const afterLoadData = (sourceData: any[], initialLoad: boolean, source: string | undefined) => {
        const hot = hotRef?.current?.hotInstance;
        const newData = [...sourceData];
        for (let i = 0; hot && i < sourceData.length; i++) {
            if ('no_status' === (sourceData[i][0] as string)) {
                newData[i][0] = noStatus;
            }
        }
        hot?.updateData(newData);
    };

    const formatList = (l: IList) => {
        const newData = l.data.map((data) => {
            const newRow = [...data];
            if ((newRow[0] as string) === 'no_status') {
                newRow[0] = noStatus;
            }
            return newRow;
        });

        return {
            ...l,
            data: newData,
        };
    };

    const formatedList = useMemo(() => formatList(list), [list.data, list.name]);

    return (
        <Box m={4}>
            <Grid
                toolId={toolId}
                paramHotRef={hotRef}
                headers={MObjectifSearchHeader}
                list={formatedList}
                afterValidate={afterValidate}
                afterLoadData={afterLoadData}
            >
                <HotColumn
                    validator={listValidator(newStatus)}
                    title={requireTitle(translatedHeaders[0])}
                    source={newStatus}
                    type="autocomplete"
                >
                    <AutoCompleteRenderer list={newStatus} hot-renderer />
                </HotColumn>
                <HotColumn
                    type="text"
                    validator={numberValidator()}
                    allowEmpty={false}
                    title={requireTitle(translatedHeaders[1])}
                />
                <HotColumn type="text" validator={numberValidator(true)} title={translatedHeaders[2]} />
            </Grid>
        </Box>
    );
};
